<template lang="pug">
div
  
  div(@click='modal_open')
    slot(name='activator')
  liondesk-dialog(
    v-if="authStatus === 'disconnected'"
    v-model='isModalVisible',
    :dialog-title='"Log In To Zipform"',
    cancel-button-text='Close',
    hide-ok-button,
    @click:cancel='closeModal',
    :width='"650"'
  )
    v-container.pa-0.ma-0.fill-height.text-xs-center(slot='body')
      v-layout.px-1.pa-2.pb-0(column, align-center)
        v-img.txZipform-logo(:src='txZipformLogo', width='350', height='71')
        v-flex.mt-4.form-container(xs3)
          p.mb-4.font-weight-bold.login-header.text-sm-left
            | To allow LionDesk to access your data, please sign in
          v-layout(column, align-center, justify-space-between)  
            v-text-field.pa-0.mb-4.login-input(
              v-model='username'
              label='username'
              solo
              hide-details
              single-line
              clearable
              flat
            )
            v-text-field.login-input(
              v-model='password'
              label='password'
              type='password'
              solo
              hide-details
              single-line
              clearable
              flat
            )
        v-flex.mt-4.mb-0.form-container(xs3)
          v-btn.mt-2.primary.apply-btn(
            @click='signInToZipform()'
          )
            | SIGN IN
          v-layout(column, align-center, justify-space-between) 
            a.pa-0.mb-0.mt-2.login-help-text(:href='forgotUsernameOrPasswordZipformLink' target='_blank') Forgot username / password
            a.pa-0.ma-0.login-help-text(:href='createZipformAccountLink' target='_blank') Create a zipForm account
        v-snackbar(:value="authStatusErr" color="red darken-2")
          span Error checking zipForm user status
        v-snackbar(:value="authError" color="red darken-2")
          span Error signing in to zipForm
  liondesk-dialog(
    v-model='isModalVisible',
    v-if="authStatus === 'connected'"
    :dialog-title='"Create Zipform Transaction"',
    ok-button-text='Create and go to Zipform',
    @click:cancel='closeModal',
    @click:ok='createZipformTransaction()',
    :width='"650"'
  )
    v-container.pa-0.ma-0.text-xs-center.fill-height(slot='body')
      v-layout.px-1(column, align-center, justify-space-between)
        .pa-2
          v-img.txZipform-logo(:src='txZipformLogo', width='350', height='71')
        v-flex.mt-4.form-container(xs3)
          p.mb-1.font-weight-bold.text-sm-left
            | Transaction details
          v-layout(row, justify-space-between)
            v-text-field.form-input(
              label='Transaction name*',
              placeholder=' ',
              v-model='transactionName',
              hide-details
            )
            v-select.form-input(
              label='Transaction type*',
              v-model='selectedTxType',
              :items='transactionTypes',
              hide-details
            )
        v-flex.mt-4.form-container(xs3)
          v-layout(row, justify-space-between)
            v-select.form-input(
              label='Property type',
              v-model='selectedPropType',
              :items='propertyTypes',
              hide-details
            )
            v-select.form-input(
              label='Role',
              v-model='selectedRole',
              :items='roles',
              hide-details
            )
          p.ma-0.pt-3.text-sm-left.caption.grey--text * Field is required
        v-flex.mt-3.form-container(xs3)
          p.mb-2.font-weight-bold.text-sm-left
            | zipForm contact
          v-layout.mb-3(row, justify-space-between)
            v-text-field.mt-0.form-input(
              label='First name',
              v-model='contact.first_name',
              hide-details,
              :readonly='readOnly.first_name'
            )
            v-text-field.mt-0.form-input(
              label='Last name',
              v-model='contact.last_name',
              hide-details,
              :readonly='readOnly.last_name'
            )
          v-layout.mt-3(row, justify-space-between)
            v-text-field.mt-0.form-input(
              label='Phone',
              v-model='contact.mobile_phone',
              single-line,
              :rules='[rules.format]',
              :readonly='readOnly.mobile_phone'
            )
            v-text-field.mt-0.form-input(
              label='Email',
              v-model='contact.email',
              hide-details,
              :readonly='readOnly.email'
            )
          v-snackbar(:value="errorMsg" :key="errorMsgKey" color="red darken-2")
            span Error while creating transaction
          p.pa-0.ma-0.mt-3.text-sm-left.red-darken-2--text.bottom-text Additional transaction fields can be filled out in ZipForm after you clicked create and go to ZipForm
          p.pa-0.red--text.caption(v-if='displayWarningMsg') Please select/fill all fields.
</template>

<script>
import LiondeskDialog from '@/Core/components/LiondeskDialog';

import Modal from '@/Core/mixins/modal';
import { mapState, mapActions, mapGetters } from 'vuex';
import { PHONE_REGEX } from "@/Core/config/regex";
import {
  PURCHASE,
  RESIDENTIAL,
  BUYER,
  SELLER,
  INVALID_PHONE_NUMBER,
  TRANSACTION_TYPES,
  PROPERTY_TYPES,
} from '@/Contacts/components/actions/constants';

export default {
  name: 'CreateZipformTransaction',
  components: {
    LiondeskDialog,
  },
  mixins: [Modal],
  props: {
    addEvents: {
      type: Function,
    },
    selectedIds: {
      type: Array,
    },
    closeWhenLogin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      username: '',
      password: '',
      contact: {
        first_name: '',
        last_name: '',
        mobile_phone: '',
        email: '',
        id: Number,
      },
      transactionName: '',
      transactionTypes: TRANSACTION_TYPES,
      propertyTypes: PROPERTY_TYPES,
      selectedTxType: '',
      selectedPropType: RESIDENTIAL,
      roles: [BUYER, SELLER],
      selectedRole: '',
      rules: {
        format: value => {
          return PHONE_REGEX.test(value) || INVALID_PHONE_NUMBER;
        },
      },
      isPhoneNumberValid: false,
      txZipformLogo: '/static/img/lw-zipform-logo.svg',
      displayWarningMsg: false,
      readOnly: {
        first_name: false,
        last_name: false,
        mobile_phone: false,
        email: false,
        zipformResp: {},
        zipformErr: '',
      },
      forgotUsernameOrPasswordZipformLink: `${process.env.VUE_APP_INTEGRATIONS_ZIPFORM_FORGOT_PASSWORD}`,
      createZipformAccountLink: `${process.env.VUE_APP_INTEGRATIONS_ZIPFORM_CREATE_ACCOUNT}`,
    };
  },
  watch: {
    selectedTxType(selected) {
      this.defaultRoleSelection(selected);
    },
    watchPhoneNumber(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.isPhoneNumberValid = PHONE_REGEX.test(newValue);
    },
    zipformTxResp(newValue, oldValue) {
      if (newValue === oldValue) return;
      if (!this.errorMsg) {
        this.closeModal();
        this.openZipformTxURL();
        this.addZipformTxToTimeline();
      }
    },
  },
  computed: {
    ...mapGetters('contact', ['currentContact']),
    ...mapState('zipformTransaction', [
      'zipformTxResp',
      'errorMsg',
      'errorMsgKey',
      'authStatus',
      'authStatusErr',
      'authError',
      'zipformTXLoading',
      ]),
    watchPhoneNumber() {
      return this.contact.mobile_phone;
    },
  },
  created() {
    this.checkZipformAuthentication();
    this.contact = {
      first_name: this.currentContact.first_name,
      last_name: this.currentContact.last_name,
      mobile_phone: this.currentContact.mobile_phone,
      email: this.currentContact.email,
      id: this.currentContact.id,
    };
    this.transactionName = `${this.contact.first_name} ${this.contact.last_name}`;
    this.setIfShouldBeReadOnly();
  },
  methods: {
    ...mapActions('zipformTransaction', [
      'setZipformTransaction',
      'getIntegrationStatus',
      'submitZipformAuth',
      ]),
    checkZipformAuthentication(){
      this.getIntegrationStatus();
    },
    openZipformTxURL() {
      window.open(this.zipformTxResp.data.description);
    },
    async createZipformTransaction() {
      if (
        !this.transactionName ||
        !this.selectedTxType
      ) {
        this.displayWarningMsg = true;
        return;
      }
      this.displayWarningMsg = false;

      await this.setZipformTransaction({
        contact: this.contact,
        transactionName: this.transactionName,
        transactionType: this.selectedTxType,
        role: this.selectedRole,
        propertyType: this.selectedPropType,
      });
    },
    async signInToZipform() {
      const body = {
        user_name: this.username,
        password: this.password,
      }
      await this.submitZipformAuth(body);

      if (!this.closeWhenLogin || this.authStatus !== 'connected') return;

      this.closeModalOnLogin();
    },
    async addZipformTxToTimeline() {
      this.$emit('contact-updated');
    },
    setIfShouldBeReadOnly() {
      this.readOnly.first_name = this.currentContact.first_name ? true : false;
      this.readOnly.last_name = this.currentContact.last_name ? true : false;
      this.readOnly.mobile_phone = this.currentContact.mobile_phone ? true : false;
      this.readOnly.email = this.currentContact.email ? true : false;
    },
    defaultRoleSelection(value) {
      if (value === PURCHASE) {
        this.selectedRole = BUYER;
        return;
      }
      this.selectedRole = SELLER;
    },
    open_modal() {
      this.modal_open();
    },
    closeModal() {
      this.$emit('on-modal-closed');
      this.modal_close();
    },
    closeModalOnLogin() {
      this.$emit('on-login-success');
      this.modal_close();
    },
  },
};
</script>

<style lang="scss" scoped>
.login-header {
  font-size: 18px;
  margin-left: 10px;
}
.login-input {
  padding: 0;
  border: 2px solid var(--v-background-lighten4);
  width: 95%;
}
.login-help-text {
  color: var(--v-primary-base);
}
.form-container {
  width: 600px;
}
.form-input {
  max-width: 285px;
}
.bottom-text {
  color: var(--v-secondary-lighten3);
}
</style>
